import { Grid, makeStyles, Paper, createStyles } from '@material-ui/core';
import { useMemo } from 'react'
import { useWatch } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import FormTitle from "../../../yoello-lib/modules/dynamicForms/FormComponents/FormTitle";
import DynamicForm from '../../../yoello-lib/modules/dynamicForms/DynamicForms';
import FormAlongsideText from '../../../yoello-lib/modules/dynamicForms/FormComponents/FormAlongsideText';
import { FormMaskedText } from '../../../yoello-lib/modules/dynamicForms/FormComponents/FormMaskedText';
import FormSwitchWithText from '../../../yoello-lib/modules/dynamicForms/FormComponents/FormSwitchWithText';
import FormTextBox from '../../../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox';
import { FormErrors } from '../../../yoello-lib/modules/dynamicForms/FormErrors';
import EColourPanel from '../../../yoello-lib/modules/dynamicForms/interfaces/EColourPanel';
import ICommonFormProps from '../../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps'
import IDynamicFormRow from '../../../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow';
import ListLoading from '../../util/Loading';
import { usePopUpMessages } from './usePopUpMessages';
import { IYoelloTheme } from '../../../yoello-lib/modules/themes/IYoelloTheme';
import { PERMISSIONS } from '../../../const/permissions.const';
import useCheckPermissions from '../../../hooks/useCheckPermissions';

const useStyles = makeStyles((theme: IYoelloTheme) =>
  createStyles({
    root: {
      flexDirection: "row-reverse"
    }

  }),
);

export function PopUpMessagesForm() {
  const { t } = useTranslation();
  const { bannerMessages, onBannerMessagesSubmit, isLoading } = usePopUpMessages();
  const { hasPermission, onFailedInteraction } = useCheckPermissions(PERMISSIONS.ORDER_SETTINGS_MANAGEMENT);
  const { root } = useStyles();
  const formRows = useMemo(() => {
    const rows: IDynamicFormRow[] = [
      {
        label: "forms.orders.PopUpMessage.enableTitle",
        keyName: "enabled",
        Component: FormSwitchWithText,
        className: root,
        formProps: {
          secondLabel: "forms.orders.PopUpMessage.description",
          secondLabelJSX: (
            <Trans i18nKey='forms.settings.preOrder'>
              0<b>1</b>2
            </Trans>
          ),
          hasStatus: true
        },
      },
      {
        label: "",
        keyName: "",
        Component: PopUpMessageFormFileds,
      },
    ]
    return rows;
  // eslint-disable-next-line  
  }, [bannerMessages, isLoading])


  return (
    <Paper style={{ padding: '2rem', marginBottom: '1.5625rem' }}>
      <FormTitle title={t("forms.orders.PopUpMessage.title")} />
      {
        isLoading ? <ListLoading /> :
          <DynamicForm
            useFormOptions={{
              mode: "onChange", reValidateMode: "onChange"
            }}
            onHandleSubmit={onBannerMessagesSubmit}
            disableAllInteraction={onFailedInteraction}
            disableAll={!hasPermission}
            formData={bannerMessages}
            formRows={formRows}
            formButtons={{
              rightButton: {
                type: "submit",
                label: t("forms.orders.PopUpMessage.updatePopUp"),
                color: EColourPanel.PRIMARY
              },
            }}
          />
      }
    </Paper>
  )
}


function PopUpMessageFormFileds(props: ICommonFormProps) {
  const { control } = props;
  const { t } = useTranslation();
  const enabled = useWatch({
    control,
    name: 'enabled'
  })
  function checkText(value: string) {
    return value.trimStart();
  }
  if (!enabled) return null;
  return <Grid container
    spacing={3}>

    <Grid item xs={12}>
      <FormAlongsideText
        label={"forms.orders.PopUpMessage.secondLabel"}
        secondLabel={"forms.orders.PopUpMessage.secondLabelDescription"}
      />
    </Grid>
    <Grid item xs={12}>
      <FormMaskedText formProps={{
        ...props.formProps,
        maskOnChange:checkText
      }} {...props} keyName={"title"} label={t("forms.orders.PopUpMessage.messageTitle")} registerOptions={{ required: true}} />
      <FormErrors {...props} keyName={"title"} label={t("forms.orders.PopUpMessage.messageTitle")} />

    </Grid>
    <Grid item xs={12}>
      <FormTextBox {...props}
      formProps={{
        ...props.formProps,
        onValueChange: (value: any) =>checkText(value)
      }}
        keyName={"message"}
        label={t("forms.orders.PopUpMessage.messageMessage")}
        registerOptions={{ required: true }}
        inputProperties={{
          type: 'text',
          multiline: true,
          rows: 4,
        }} />
      <FormErrors {...props} keyName={"message"} label={t("forms.orders.PopUpMessage.messageMessage")} />
    </Grid>
  </Grid>
}
